import { isNullOrWhiteSpace } from "../../Utilities/string";

document.querySelectorAll<HTMLButtonElement>("[data-copy-button]").forEach(button => {
  button.addEventListener("click", async () => {
    const copyText = button.dataset.copyText;

    if (!isNullOrWhiteSpace(copyText)) {
      button.classList.add("htmx-request");

      await navigator.clipboard.writeText(copyText);

      button.classList.remove("htmx-request");

      const widthFrom = button.getBoundingClientRect().width;

      button.dataset.copied = "true";

      // Perform a simple width-animation
      const widthTo = button.getBoundingClientRect().width;

      button.style.width = `${widthFrom}px`;

      window.requestAnimationFrame(() => {
        button.style.width = `${widthTo}px`;

        setTimeout(() => (button.style.width = ""), 250);
      });
    }
  });
});
